// extracted by mini-css-extract-plugin
export default {"input":"radio-input_input__H9WcS","label":"radio-input_label__M7jdz"};